import React, { Component } from 'react';

class ModalSuccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      message: ''
    };
  }
  render() {
    return (
      <div className="modal fade" id="centralModalSuccess" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-notify modal-success" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <p id="title-p" className="heading lead"></p>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" className="white-text">&times;</span>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="text-center">
                        <i className="fa fa-check fa-4x mb-3 animated rotateIn"></i>
                        <p id="msg-p"></p>
                    </div>
                </div>

                <div className="modal-footer justify-content-center">
                    <a type="button" className="btn btn-outline-success waves-effect" data-dismiss="modal">Okay</a>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default ModalSuccess;
